import { useEffect } from "react";
export const useOnClickOutside = (
  ref:
    | React.RefObject<HTMLElement | null>
    | React.RefObject<HTMLElement | null>[],
  handler?: (event: MouseEvent | TouchEvent) => void,
) => {
  useEffect(() => {
    if (!handler) {
      return undefined;
    }
    const listener = (event: MouseEvent | TouchEvent) => {
      if (Array.isArray(ref)) {
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < ref.length; i++) {
          const element = ref[i].current;
          // 1つ目の要素がないからといって、2つ目の要素もなくクリック範囲に含まれていないとは言えない。
          if (element?.contains(event.composedPath()[0] as Node)) {
            return;
          }
        }
      } else {
        if (
          !ref.current ||
          ref.current.contains(event.composedPath()[0] as Node)
        ) {
          return;
        }
      }

      handler(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
};
